// extracted by mini-css-extract-plugin
export default {"main":"Alternance_main__hgrMF","container":"Alternance_container__n3Q4h","container2":"Alternance_container2__9o6rx","body":"Alternance_body__owUOQ","page":"Alternance_page__T1vk7"};